// extracted by mini-css-extract-plugin
export default {"content":"user-page_content__Hh3Xn","description":"user-page_description__HGDDy","cards":"user-page_cards__OnjyL","cards_box":"user-page_cards_box__ELEWh"};